import { IResponse, consumer } from "@bemap/utils";

const ENDPOINT = `/assessments`

export const getAssessmentById = async (hash: string): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/${hash}/hash`);
}

export const unlock = async (hash: string): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/${hash}/unlock`, {});
}

export const findWords = async (): Promise<IResponse> => {
  return consumer('GET', '/words');
}

export default {
  getAssessmentById,
  unlock,
  findWords,
}